












export default
  name: 'TopStorePage'

  components: {
  }

  data: () ->
    active: false

  props:
    src:
      type: String
      default: ''
    title:
      type: String
      default: ''
    light_blue:
      type: Boolean
      default: false
    light_yellow:
      type: Boolean
      default: false
    light_blue2:
      type: Boolean
      default: false
    reverse:
      type: Boolean
      default: false
    url:
      type: String
      default: ''

  mounted: () ->
    window.addEventListener('scroll', @scroll)
  destroyed: () ->
    window.removeEventListener('scroll', @scroll)

  methods: {
    scroll:() ->
      if @light_blue
        @active = false
        if document.querySelector('.light_blue')
          if window.scrollY > document.querySelector('.light_blue').offsetTop - window.innerHeight / 2
            @active = true
      if @light_blue2
        @active = false
        if document.querySelector('.light_blue2')
          if window.scrollY > document.querySelector('.light_blue2').offsetTop - window.innerHeight / 2
            @active = true
      if @light_yellow
        @active = false
        if document.querySelector('.light_yellow').offsetTop
          if window.scrollY > document.querySelector('.light_yellow').offsetTop - window.innerHeight / 2
            @active = true
  }
